export default __webpack_public_path__ + "static/carbonift-b1b28dc2e6a8e6d69bff38ed71bc359b.png";